/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Options02({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M3.47 5.1H1.5a.6.6 0 0 1 0-1.2h1.97a2.601 2.601 0 1 1 0 1.2Zm1.13-.6a1.4 1.4 0 1 0 2.8 0 1.4 1.4 0 0 0-2.8 0Z" clipRule="evenodd" /><path fill="currentColor" d="M10.5 3.9a.6.6 0 1 0 0 1.2h4a.6.6 0 1 0 0-1.2h-4Z" /><path fill="currentColor" fillRule="evenodd" d="M7.4 10.5A1.6 1.6 0 0 1 9 8.9h2a1.6 1.6 0 0 1 1.6 1.6v.4h1.9a.6.6 0 1 1 0 1.2h-1.9v.4a1.6 1.6 0 0 1-1.6 1.6H9a1.6 1.6 0 0 1-1.6-1.6v-2Zm4 0v2a.4.4 0 0 1-.4.4H9a.4.4 0 0 1-.4-.4v-2c0-.22.18-.4.4-.4h2c.22 0 .4.18.4.4Z" clipRule="evenodd" /><path fill="currentColor" d="M5.5 10.9a.6.6 0 1 1 0 1.2h-4a.6.6 0 1 1 0-1.2h4Z" /></svg>;
}
;